import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className="container">
      <div className={styles.footer}>
        <Link to="/" className={styles.brand}>
          <span className={styles.ax}>AX</span>
          Pattern Library
        </Link>
        <nav className={styles.links} aria-label="Footer">
          <Link to="/glossary">Glossary</Link>
          <Link to="/compare">Compare</Link>
          <Link to="/quiz">Find your pattern</Link>
        </nav>
      </div>
    </footer>
  );
}
